export interface CollaboratorAwareness {
  userId: string;
  name: string;
  color: string;
  selectedNodeId: string | null;
  editingNodeId: string | null;
}

/** 10 distinct colors for collaborators. */
export const COLLABORATOR_COLORS = [
  '#ef4444', '#f97316', '#eab308', '#22c55e', '#06b6d4',
  '#3b82f6', '#8b5cf6', '#ec4899', '#14b8a6', '#f43f5e',
] as const;

/** Deterministically assign a color to a userId via simple hash. */
export function assignColor(userId: string): string {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = ((hash << 5) - hash + userId.charCodeAt(i)) | 0;
  }
  return COLLABORATOR_COLORS[Math.abs(hash) % COLLABORATOR_COLORS.length]!;
}
